import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiResponse } from '../../shared/models/api-response';
import { StudentInfo } from './student.models';
@Injectable({
  providedIn: 'root'
})
export class StudentService {

  constructor(private http: HttpClient) { }

  getstudentno(licenseId: string) {
    return this.http.get<ApiResponse<StudentInfo>>("api/student/GetStudentInfo?licensekey=" + licenseId);
  }

}

